<template>
  <div class="navigation"
    v-if="isAuthenticated">
    <div @click="$router.push({name: 'admin'})"><span class="material-symbols-outlined">home</span>&nbsp;<label>Home</label></div>
    <div @click="$router.push({name: 'contacts'})"><span class="material-symbols-outlined">contacts</span>&nbsp;<label>Contacts</label></div>
    <div @click="$router.push({name: 'processpdf'})"><span class="material-symbols-outlined">conveyor_belt</span>&nbsp;<label>Process PDF</label></div>
    <div @click="$router.push({name: 'pdfsprocessed'})"><span class="material-symbols-outlined">home_storage</span>&nbsp;<label>PDFS</label></div>
    <div @click="$router.push({name: 'dboptions'})"><span class="material-symbols-outlined">database</span>&nbsp;<label>DB Options</label></div>
    <div @click="$router.push({name: 'configuration'})"><span class="material-symbols-outlined">build</span>&nbsp;<label>Configuration</label></div>
    <div @click="$router.push({name: 'settings'})"><span class="material-symbols-outlined">settings</span>&nbsp;<label>Settings</label></div>
  </div>
</template>

<script>
export default {
  name: 'NavigationControl',
  async mounted () {
    this.setIsAuthenticated(await this.verified())
    if(!this.isAuthenticated) {
      this.$router.push('/')
    }
  }
}
</script>

<style>
.navigation {
  margin-top: .8rem;
  background-color: #8b5738;
  color: #fff;
  display: flex;
  flex-direction: row;
  width: 100%; 
  padding: .6rem 1%;
  justify-content: center;
}

.navigation > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 1.6rem;
}
</style>